// extracted by mini-css-extract-plugin
export var active = "_ev-7";
export var container = "_ev-0";
export var evenWidth = "_ev-4";
export var large = "_ev-5";
export var outlet = "_ev-8";
export var slide = "_ev-2";
export var small = "_ev-6";
export var tab = "_ev-3";
export var tabs = "_ev-1";